import { withI18n } from 'react-i18next';
import EmptyInvoices from './EmptyInvoices';

export const pureComponent = EmptyInvoices;
export default withI18n()(EmptyInvoices);
